module.exports = __webpack_public_path__ + "static/media/Medical-marijuana-logo.4fa43b16.png";